module.exports = __webpack_public_path__ + "img/Afes-logo.2aa46c30.png";